import React from 'react';

import { type FWaypointTemplateFragment } from '@dashboard/generated/wp/platform';
import { useDraggable } from '@dnd-kit/core';
import { Box } from '@mui/material';

import TemplateSummaryCard from './TemplateSummaryCard';

const GRID_COLUMN_SX = { gridColumn: { xs: 'span 12', sm: 'span 6', md: 'span 4', lg: 'span 3' } };

type Props = {
  template: FWaypointTemplateFragment;
  disabled?: boolean;
};

export default function DraggableTemplateCard({ template, disabled = false }: Props) {
  if (disabled) {
    return (
      <Box sx={GRID_COLUMN_SX} onDragStart={(e) => e.preventDefault()}>
        <TemplateSummaryCard template={template} />
      </Box>
    );
  }
  return <DraggableInner template={template} />;
}

function DraggableInner({ template }: { template: FWaypointTemplateFragment }) {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: template.id,
    data: {
      type: 'template',
      id: template.id,
    },
  });

  const style: React.CSSProperties = {
    opacity: isDragging ? 0.4 : 1,
    cursor: isDragging ? 'grabbing' : 'grab',
    touchAction: 'none',
  };

  return (
    <Box ref={setNodeRef} style={style} {...attributes} {...listeners} sx={GRID_COLUMN_SX}>
      <TemplateSummaryCard template={template} />
    </Box>
  );
}
